import _get from 'lodash/get';
import moment from 'moment';
import 'moment/locale/ar';
import { setLocale as setYupLocale } from 'yup';
import en from '@/i18n/en';

// import elementUIEn from 'element-ui/lib/locale/lang/en';
import elementUIEn from 'quasar/lang/en-us';
import elementUIAr from 'quasar/lang/ar';

import ar from '@/i18n/ar';
import service from '@/modules/auth/auth-service';
// import { storeAsync } from '@/app-module';

let currentLanguageCode = null;

const languages = {
  en: {
    id: 'en',
    label: 'English',
    flag: '/images/englishFlag.svg',
    dictionary: en,
    elementUI: elementUIEn,
  },
  ar: {
    id: 'ar',
    label: 'العربية',
    flag: '/images/saudiFlag.svg',
    dictionary: ar,
    elementUI: elementUIAr,
  },
};

async function init() {
  let langFromHtml = document.documentElement.lang 
  console.log('Lang From Html : ', langFromHtml)
  // const items = { ...localStorage };
  // console.log('items', items)


  currentLanguageCode = location.hostname.includes('localhost') 
    ? localStorage.getItem('language') || langFromHtml 
    : langFromHtml;
    // localStorage.getItem('language') || 'en';

  let lang = currentLanguageCode;

  let currentUser = localStorage.getItem('currentUser');
  if (currentUser) {
    let user = service.decryption(
      currentUser,
      'secret-c-u',
    );

    user.lang = lang;

    localStorage.setItem(
      'currentUser',
      service.encryption(user, 'secret-c-u'),
    );
  }

  // createIframe();
  setLanguageCode(lang);
}

function getLanguage() {
  return languages[getLanguageCode()];
}

function format(message, args) {
  if (!message) {
    return null;
  }

  try {
    return message.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match;
    });
  } catch (error) {
    console.error(message, error);
    throw error;
  }
}

export function getLanguages() {
  return Object.keys(languages).map((language) => {
    return languages[language];
  });
}

export function getElementUILanguage() {
  return getLanguage().elementUI;
}

export function getLanguageCode() {
  if (!currentLanguageCode) {
    init();
  }

  return currentLanguageCode;
}

export function setLanguageCode(arg) {
  if (!languages[arg]) {
    throw new Error(`Invalid language ${arg}.`);
  }

  moment.locale(arg);

  currentLanguageCode = arg
  localStorage.setItem('language', arg);
  // storeAsync().dispatch('saryahLanding/landing/changeCurrentLanguageCode', arg);
  // saveDataToIframe('language', arg);

  if (getLanguage().dictionary.validation) {
    setYupLocale(getLanguage().dictionary.validation);
  }
}

export function i18nExists(key) {
  const message = _get(getLanguage().dictionary, key);
  return !!message;
}


export function i18n(key, ...args) {
  const message = _get(getLanguage().dictionary, key);

  if (!message) {
    return key;
  }

  return format(message, args);
  // return this.$t(key, args);
}




// function createIframe() {
//   const domains = [
//     "http://localhost:8082/",
//     "https://saryahapp.com/",
//     "https://ar.saryahapp.com/"
//   ]
//   window.addEventListener("message", messageHandler, false);
//   function messageHandler(event) {
//     if (!domains.includes(event.origin))
//       return;

//     const { action, key, value } = event.data
//     if (action == 'save'){
//       window.localStorage.setItem(key, JSON.stringify(value))
//     } else if (action == 'get') {
//       let json = JSON.parse(window.localStorage.getItem(key))
//       event.source.postMessage({
//         action: 'returnData',
//         key,
//         json
//       }, '*')
//     }
//   }
// }

// export function saveDataToIframe(key, data) {
//   const iframe = document.getElementById('iframe-id')
//   iframe.contentWindow.postMessage({
//     action: 'save',
//     key: key,
//     value: data
//   })
// }

// export function getDataFromIframe(key) {
//   const iframe = document.getElementById('iframe-id')
//   iframe.contentWindow.postMessage({
//     action: 'get',
//     key: key
//   })

//   window.addEventListener("message", messageHandler, false);

//   function messageHandler(event) {
//     const { action, key, value } = event.data
//     if (action == 'returnData'){
//       useData(key, value)
//     }
//   }
// }

// const domains = [
//   "http://localhost:8082/",
//   "https://saryahapp.com/",
//   "https://ar.saryahapp.com/"
// ]

// // document.domain = "example.com";
// window.onmessage = function(e) {
//     if (!domains.includes(e.origin)) {
//       return;
//     }
//     var payload = JSON.parse(e.data);
//     switch(payload.method) {
//         case 'set':
//             localStorage.setItem(payload.key, JSON.stringify(payload.data));
//             break;
//         case 'get':
//             var parent = window.parent;
//             var data = localStorage.getItem(payload.key);
//             parent.postMessage(data, "*");
//             break;
//         case 'remove':
//             localStorage.removeItem(payload.key);
//             break;
//     }
// };

// window.onload = function() {
//   var iframe = document.getElementsByTagName('iframe')[0];
//   var win;
//   // some browser (don't remember which one) throw exception when you try to access
//   // contentWindow for the first time, it work when you do that second time
//   try {
//       win = iframe.contentWindow;
//   } catch(e) {
//       win = iframe.contentWindow;
//   }
//   var obj = {
//      name: "Jack"
//   };
//   // save obj in subdomain localStorage
//   win.postMessage(JSON.stringify({key: 'storage', method: "set", data: obj}), "*");
//   window.onmessage = function(e) {
//       if (!domains.includes(e.origin)) {
//           return;
//       }
//       // this will log "Jack"
//       console.log(JSON.parse(e.data).name);
//   };
//   // load previously saved data
//   win.postMessage(JSON.stringify({key: 'storage', method: "get"}), "*");
// };